import { useTranslation } from "@/i18n/useTranslation";
import type { Language } from "@/i18n/translations";

const languages: { code: Language; label: string; full: string }[] = [
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
  { code: "it", label: "IT", full: "Italiano" },
  { code: "fr", label: "FR", full: "Français" },
];

export function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();
  return (
    <div className="inline-flex items-center rounded-lg border border-border bg-white p-0.5">
      {languages.map((l) => {
        const active = l.code === language;
        return (
          <button
            key={l.code}
            onClick={() => setLanguage(l.code)}
            className={`px-2.5 py-1 text-xs font-semibold rounded-md transition-colors ${
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
            aria-pressed={active}
            aria-label={l.full}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
